import React from 'react';
import { PuffLoader } from 'react-spinners';

export default function Loader() {
  return <PuffLoader color="#000000" loading={true} size={25} />;
}
